import type { CanvasPanelState } from '../../../components/ProjectCanvas/ProjectCanvas.types'
import type { CanvasShortcutTarget } from '../../../components/ProjectCanvas/hooks/useCanvasPanelShortcut'

/**
 * Was `N` bzw. `⇧N` aus dem aktuellen Zustand des Projekt-Canvas machen.
 *
 * Jede Taste gehört EINER Größe: `N` der maximierten, `⇧N` dem Split. Sie
 * bringt ihre Größe herein — von wo auch immer — und schließt nur, wenn genau
 * diese Größe schon steht.
 *
 * ```
 *              N              ⇧N
 * geschlossen  → maximiert    → Split
 * Split        → maximiert    → geschlossen
 * maximiert    → geschlossen  → Split
 * ```
 *
 * Damit führt jede Taste in einem Anschlag dorthin, wofür sie steht, und ein
 * zweiter Anschlag derselben Taste räumt wieder auf.
 *
 * **Bewusst kein Rundlauf durch die Größen** (früher: geschlossen → Split →
 * maximiert → geschlossen → …). Dort hing es von der Ausgangslage ab, wie oft
 * man drücken musste, und `N` schloss nie.
 *
 * @example
 * nextCanvasPanelState('closed', 'maximized')     // → 'maximized'
 * nextCanvasPanelState('maximized', 'split')      // → 'split'
 * nextCanvasPanelState('split', 'split')          // → 'closed'
 */
export function nextCanvasPanelState(
  current: CanvasPanelState,
  target: CanvasShortcutTarget,
): CanvasPanelState {
  return current === target ? 'closed' : target
}
